// [TODO] I got it to where each instanceVariable has a convert2stringOverride, allowing the customer
// to select which variables are in convert2string. Need to determine sformatf symbol and whether enum
// so can put .name()
virtual function string convert2string();
{{#each convertToStringInstanceVariables}}
{{ identifier }} {{ fieldMacroType }}
{{/each}}
return $sformatf("{{#each convertToStringInstanceVariables delimeter=" "}}{{ identifier }}=%s{{/each}}", {{#each convertToStringInstanceVariables delimeter=", "}}{{ identifier }}=%s{{/each}});
endfunction
